/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import * as tslib_1 from "tslib";
import { HateosResponse } from './hatoesResponse';
var HateosPagedResponse = /** @class */ (function (_super) {
    tslib_1.__extends(HateosPagedResponse, _super);
    function HateosPagedResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HateosPagedResponse;
}(HateosResponse));
export { HateosPagedResponse };
//# sourceMappingURL=hatoesPagedResponse.js.map